import { render } from "./StackedColumns.vue?vue&type=template&id=77c6f1df&scoped=true"
import script from "./StackedColumns.vue?vue&type=script&lang=js"
export * from "./StackedColumns.vue?vue&type=script&lang=js"

import "./StackedColumns.vue?vue&type=style&index=0&id=77c6f1df&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c6f1df"]])

export default __exports__